import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { HelperViewContextual } from '@warrenbrasil/nebraska-web';

interface Props {
  hasFilterSelected: boolean;
}
interface Emit {
  (event: 'on-clear-filters'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersTableEmptyState',
  props: {
    hasFilterSelected: { type: Boolean }
  },
  emits: ["on-clear-filters"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'on-clear-filters'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  hasFilterSelected: boolean;
}





const emptyStateHelperViewProps = computed(() => {
  if (props.hasFilterSelected) {
    return {
      icon: 'BB0040',
      type: 'info',
      title: 'Nenhuma ordem encontrada',
      description: 'Tente alterar os filtros',
      buttonLabel: 'Limpar filtros'
    };
  }

  return {
    icon: 'BB0040',
    type: 'info',
    description: 'Você não possui ordens'
  };
});

const emitOnClearFilters = () => {
  emit('on-clear-filters');
};

return { __sfc: true,props, emit, emptyStateHelperViewProps, emitOnClearFilters, HelperViewContextual }
}

})